import DEFAULT, { configureType, PRODUCT_WIDGET_DATA, variantTypes } from './constants';
import widgetTypes from './constants/widgetTypes';
const SHADE = 'Shade';
const SIZE = 'Size';
// This function used for ['6987, 8667'] => '6897;8667' to send into the DWH.
export const transformBrandIdsParams = (value = ['-1']) => {
    let brandIds;
    try {
        brandIds = value.join(';');
    }
    catch (error) {
        brandIds = '-1';
    }
    return brandIds;
};
export const getTrackingParams = (trackingData, pwType, store, pagePrefix) => {
    const { namespace0, pageData2, namespace1, position1, namespace2, transaction_id, brand_ids, } = trackingData;
    const transformedBrandIds = transformBrandIdsParams(brand_ids);
    const params = [store || DEFAULT.STORE, pagePrefix || DEFAULT.PAGE_PREFIX, namespace0 || '', pageData2 || '', namespace1 || '', pwType || '', position1 || '', namespace2 || '', transformedBrandIds || '-1', transaction_id || ''];
    return params.join(':');
};
//  creating the query parameters
const encodeQueryData = (data) => {
    const res = [];
    Object.keys(data).forEach((key) => {
        res.push(`${key}=${data[key]}`);
    });
    return res.join('&');
};
export const getUrlWithTrackingParams = (url = '', trackingParams, pageSource = '') => {
    const isQueryParams = url.indexOf('?') > -1;
    let queryParams = { intcmp: trackingParams };
    if (pageSource) {
        queryParams = Object.assign(Object.assign({}, queryParams), { pagesource: pageSource });
    }
    if (isQueryParams) {
        return `${url}&${encodeQueryData(queryParams)}`;
    }
    return `${url}?${encodeQueryData(queryParams)}`;
};
export const getRoundedDiscount = (discount) => {
    const parsedDiscount = Number(discount);
    if (Number.isNaN(parsedDiscount)) {
        return 0;
    }
    const roundedNumber = Math.round(parsedDiscount);
    if (roundedNumber < 0) {
        return 0;
    }
    if (roundedNumber > 100) {
        return 100;
    }
    return roundedNumber;
};
export const getImageUrl = (media) => {
    let imageUrl = '';
    if (media) {
        imageUrl = media[0].url || '';
    }
    return imageUrl;
};
export const getVariantTypeV2 = (variantType = '') => {
    if (variantType) {
        switch (variantType.toLowerCase()) {
            case configureType.SHADE.toLowerCase():
                return variantTypes.SHADE;
            case configureType.WEIGHT_CONFIGURE.toLowerCase():
            case configureType.SIZE.toLowerCase():
                return variantTypes.SIZE;
            default:
                return '';
        }
    }
    return '';
};
export const getVariantType = (productTypeFromGludo) => {
    switch (productTypeFromGludo) {
        case 'shade':
            return SHADE;
        case 'weight_configure':
            return SIZE;
        default:
            return ' ';
    }
};
export const getPrimaryCategories = (categories) => {
    let categoryLevels = Object.assign({}, categories);
    if (Array.isArray(categories)) {
        [categoryLevels] = categories;
    }
    return categoryLevels;
};
export const getPageSource = (trackingData) => {
    const { namespace0, namespace1 } = trackingData;
    return `${PRODUCT_WIDGET_DATA}:${namespace0}:${namespace1}`;
};
//  finding the slug from the tracking url
export const getSlugfromUrl = (url) => {
    const URLsplit = url.split('/');
    const host = `${URLsplit[0]}//${URLsplit[2]}/`;
    const formattedSlug = url.replace(host, '');
    return formattedSlug;
};
// Adding Default values for Story Widget dynamic extra params {height, width, className}
export const massageDynamicHtmlParamForStoryWidget = (dynamicHtmlExtraParam = '') => {
    let finalHeight;
    let finalWidth;
    let finalClassname;
    // massaging height, width and classname
    try {
        const dynamicHtmlExtraParamObj = JSON.parse(dynamicHtmlExtraParam) || {};
        const { height = '100vh', width = '100%', className = '' } = dynamicHtmlExtraParamObj || {};
        finalHeight = height;
        finalWidth = width;
        finalClassname = className;
    }
    catch (error) {
        // specify default value incase parsing throws some error
        finalHeight = '100vh';
        finalWidth = '100%';
        finalClassname = '';
    }
    return {
        height: finalHeight,
        width: finalWidth,
        className: finalClassname,
    };
};
/*
  Encoding JS Script
  ------------------
  <script> -> %%%script%%%>
  </script> -> </&&&script&&&
  <script src={}> -> %%%script%%% src={}>

  Decoding JS
  -----------
  Decoding JS Script
  %%%script%%%>-> <script>
  </&&&script&&& -> </script>
  %%%script%%% src={}> -> <script src={}>

  Note :- Encoding | Decoding Sequence needs to be followed to avoid string corruption.
*/
export const encodeJSScript = (jsScript = '') => {
    let encodedJsScript = jsScript;
    try {
        // removing trailing spaces
        encodedJsScript = encodedJsScript.trim();
        // if empty string then return ''
        if (!encodedJsScript)
            return '';
        encodedJsScript = encodedJsScript.replace(/<script/g, '%%%script%%%');
        encodedJsScript = encodedJsScript.replace(/script>/g, '&&&script&&&');
    }
    catch (error) {
        encodedJsScript = '';
    }
    return encodedJsScript;
};
export const transformBrandIds = (value = '') => {
    try {
        let resString = value.toString();
        if (resString === '' || !resString) {
            resString = '-1';
        }
        return resString.split(',');
    }
    catch (err) {
        return ['-1'];
    }
};
export const truncateInteger = (num) => {
    let finalNumber;
    try {
        finalNumber = Math.trunc(num);
    }
    catch (error) {
        finalNumber = num;
    }
    return finalNumber;
};
/* Prepare devMode data for a widget and transform it to integer */
export const cookDevModeShareableData = (childData) => {
    let processedData = '';
    try {
        const resObj = {
            dn_widget_id: childData.wid,
            dn_inventory_id: childData.inventoryId,
            dn_inventory_name: childData.inventoryName,
            dn_page_type: childData.trackingData.namespace0,
            dn_page_section: childData.trackingData.namespace1,
            dn_page_data: childData.trackingData.pageData2,
            dn_widget_type: childData.wtype,
            dn_parent_widget_type: childData.pwType,
        };
        processedData = JSON.stringify(resObj);
    }
    catch (error) {
        processedData = '';
    }
    return processedData;
};
export const isV2orV1Widget = (widgetType = '') => {
    try {
        if ((widgetType && widgetType.indexOf('V2') > -1)
            || [widgetTypes.LIST_VIEW_WIDGET, widgetTypes.STORY].indexOf(widgetType) > -1) {
            return 'v2';
        }
        return 'v1';
    }
    catch (err) {
        return 'v1';
    }
};
